export const getAdById = (id) => {
    if (window.sessionStorage.getItem('ads')) {
        let ads = JSON.parse(window.sessionStorage.getItem('ads'))
        return ads.find(x => x.id === id);
    }
    return {}
}

export const getAdByIds = (ids = []) => {
    if (window.sessionStorage.getItem('ads')) {
        let ads = JSON.parse(window.sessionStorage.getItem('ads'))
        return ads.filter(x => ids.includes(x.id) && x.image !== undefined);
    }
    return []
}